import { createContext, useContext } from "react";

import type {
  Integration,
  UserIntegration,
} from "~/providers/integration-provider";

interface IntegrationContext {
  integrations: Integration[];
  userIntegrations: UserIntegration[];
}

export const IntegrationContext = createContext<IntegrationContext | undefined>(
  undefined,
);

export const useIntegration = () => {
  const context = useContext(IntegrationContext);

  if (context === undefined) {
    throw new Error("useIntegration must be used within a IntegrationProvider");
  }

  return context;
};
